import { Lightning, Registry } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { OptionConstants, OptionItem } from './OptionItem';
import { ScreenSize } from '../../api/ScreenSize';
import { ScrollList } from '../shared/ScrollList';

const _constants = {
  maxDisplayed: 7,
  textOffset: 20,
};

export class SelectOptionList extends Lightning.Component {
  static _template() {
    const margin2 = OptionConstants.margin * 2;
    const margin4 = OptionConstants.margin * 4;
    return {
      rect: true,
      color: Theme.Colors.Transparent,
      // color: 0xff800080,
      w: OptionConstants.w,
      Label: {
        x: margin2,
        mountY: 1,
        y: OptionConstants.h - margin2,
        w: OptionConstants.w - margin4,
        text: {
          text: 'Option title',
          ...Theme.Fonts.Option.Title,
          color: Theme.Colors.Option.Text.Normal,
        },
      },
      ItemList: {
        y: OptionConstants.h,
        h: OptionConstants.h * _constants.maxDisplayed,
        w: OptionConstants.w,
        x: 0,
        clipping: true,
        type: ScrollList,
        signals: {
          onActivate: '_optionSelected',
        },
      },
    };
  }

  _init() {
    this._optionStack = [];
  }

  /**
   * @param {OptionItem} option
   * @private
   */
  _optionSelected(option) {
    let value = option.data;
    if (value.options && value.options.length > 0) {
      this._optionStack.push(value.options);
      this._updateItemList(this._optionStack[this._optionStack.length - 1]);
      return;
    }
    this._cb && this._cb(value, option.index);
  }

  /**
   * @param {OptionList} value
   */
  set data(value) {
    this.title = value.title;
    this.tag('Label').patch({
      visible: !!this.title,
      text: {
        text: this.title,
      },
    });
    this.options = value.options;
    this._cb = value.callback;
  }

  /**
   * @param {OptionData[]} options
   */
  set options(options) {
    this._optionStack.push(options);
    this._updateItemList(options);
  }

  set centerFocusedItem(val) {
    this.tag('ItemList').centerFocusedItem = val;
  }

  _updateItemList(options) {
    const itemList = this.tag('ItemList');
    itemList.clearItems();
    options.forEach((option, idx) => {
      itemList.items.childList.a({
        type: OptionItem,
        data: option,
        index: idx,
        passSignals: {
          onActivate: true,
        },
      });
    });
    const found = options.findIndex(el => el.selected);
    if (found >= 0) {
      // todo remove timeout if we ever move away from flexbox in scrolllist
      Registry.setTimeout(() => {
        itemList.peekNext = true;
        itemList.focusTo(found);
        this._refocus();
      });
    }
    const maxItems = Math.min(_constants.maxDisplayed, options.length);
    const titleItem = this.title ? 1 : 0;
    const totalH = (maxItems + titleItem) * OptionConstants.h;
    const offset = (ScreenSize.h - totalH) * 0.5;
    this.patch({
      h: totalH,
      y: offset,
      ItemList: {
        y: OptionConstants.h * titleItem,
        h: maxItems * OptionConstants.h,
      },
    });
  }

  _getFocused() {
    return this.tag('ItemList');
  }

  _handleBack() {
    if (this._optionStack.length > 1) {
      this._optionStack.pop();
      this._updateItemList(this._optionStack[this._optionStack.length - 1]);
      return true;
    }
    return false;
  }
}
